// extracted by mini-css-extract-plugin
export default {"container":"JE6VHqRb4psFw4irzEVt"};